export default "__VITE_ASSET__Coe3jwy8__"